const initState = {
    authError:null,
    signUpSuccess:false
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case 'LOGIN_ERROR':
      return { 
        ...state, 
        authError: 'Login Faild' }
    case 'LOGIN_SUCCESS':
      console.log('Login Sucess')
      return{
          ...state,
          authError: null
      }
    case 'SIGNOUT_SUCCESS':
      console.log('Signout Success')
      return{
          ...state
      }
    case 'SIGNOUT_ERROR':
      console.log('Signout Error')
        return{
            ...state,
      }
    case 'SIGNUP_SUCCESS':
      console.log('sign up success')
      return {
        ...state,
        authError: null,
        signUpSuccess: true
      }
    case 'SIGNUP_ERROR':
      console.log('signup error')
      return{
        ...state,
        authError: action.err.message
      }
    default:
        return state;
  }
};

export default authReducer;
